import { gql } from '@apollo/client/core';

export const FETCH_PROFILE_COMPLETE_PREVIEW = gql`
  query ProfileCompletePreview($accountId: UUID!) {
    account(id: $accountId) {
      ... on Sitter {
        profiles {
          babysitter {
            profile {
              bio
              yearsExperience
              qualifications
              payRate {
                min
                max
              }
            }
          }
          nanny {
            profile {
              bio
              yearsExperience
              qualifications
              payRate {
                min
                max
              }
            }
          }
          petCare {
            profile {
              bio
              yearsExperience
              qualifications
            }
          }
          housekeeping {
            profile {
              bio
              yearsExperience
              payRate {
                min
                max
              }
            }
          }
          companionCare {
            profile {
              bio
              yearsExperience
              qualifications
            }
          }
        }
      }
    }
  }
`;
